export default __webpack_public_path__ + "static/media/refresh.b643d3d7.svg";